import {
  ButtonBase,
  ITween,
  Linear,
  SpineBase,
  dispatcher,
  ingenuity,
  Container,
  delayedCall,
  killDelayedCall,
  Label
} from "@quest/base-core";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { SelectionScreenView } from "./SelectionScreenView";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard";
import { SlotConstants } from "@quest/slot-core";

export class SelectionScreenController {
  private view: SelectionScreenView;
  private greenSelectionCard: ButtonBase;
  private blueSelectionCard: ButtonBase;
  private pinkSelectionCard: ButtonBase;
  private selectedCardNum: number;
  private selectionScreenContainer: Container;
  private FIRST_CARD: number = 1;
  private TOTAL_CARD: number = 3;
  private btnContainerIDs: number[] = [1, 2, 3];

  public constructor(view: SelectionScreenView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
  }

  // Add to initialize elements
  private initializeElements(): void {
    this.greenSelectionCard = this.view.getButtonById("button_1") as ButtonBase;
    this.blueSelectionCard = this.view.getButtonById("button_2") as ButtonBase;
    this.pinkSelectionCard = this.view.getButtonById("button_3") as ButtonBase;
    this.greenSelectionCard.alpha = 0.001;
    this.blueSelectionCard.alpha = 0.001;
    this.pinkSelectionCard.alpha = 0.001;
    this.selectionScreenContainer = this.view.getContainerByID("selectionScreenContainer");
  }

  /**
   * Method subscribeEvents to subscribe Selection screen events.
   */
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_SELECTION_SCREEN, this.onShowSelectionScreen, this);
    this.greenSelectionCard.on(ButtonBase.UP, this.handleCardClick, this);
    this.blueSelectionCard.on(ButtonBase.UP, this.handleCardClick, this);
    this.pinkSelectionCard.on(ButtonBase.UP, this.handleCardClick, this);
  }

  /**
   * Method unSubscribeEvents to un-subscribe Selection screen events.
   */
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_SELECTION_SCREEN, this.onShowSelectionScreen, this);
    this.greenSelectionCard.off(ButtonBase.UP, this.handleCardClick, this);
    this.blueSelectionCard.off(ButtonBase.UP, this.handleCardClick, this);
    this.pinkSelectionCard.off(ButtonBase.UP, this.handleCardClick, this);
  }

  // Add to show selection screen
  private onShowSelectionScreen(): void {
    this.setFreeSpinsValue();
    ingenuity.configData.isSelectionComplete = false;
    ingenuity.configData.isReelSpinMusicPlaying = false;
    ingenuity.configData.selectionScreenShowing = true;
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.HIDE_BASE_GAME_PORTRAIT_WIN_MTR);
    if ((ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining()) {
      this.showSelectionScreenInBrokenGame();
    } else {
      this.playSelectionIntroSpine();
    }
  }
  /**
   * to handle selection screen in broken
   */
  private showSelectionScreenInBrokenGame(): void {
    dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.SELECTION_SCREEN_BG_SHOW);
    this.showBooksWithBoxSync();

    setTimeout(() => {
      this.selectionScreenContainer.alpha = 0;

      this.selectionScreenContainer.visible = true;

      const fadeInTween = ingenuity.currentGame.add.tween(this.selectionScreenContainer);
      fadeInTween.to({ alpha: 1 }, 1000, Linear.None, true, 0, 0, false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
    }, 10);
    delayedCall(
      "showSelectedBookInBroken",
      1800,
      () => {
        killDelayedCall("showSelectedBookInBroken");
        this.selectedCardNum = (ingenuity.parserModel as GameParserModel).getPickChoice();
        this.disableCards();
        // this.hideBannerAnimation();
        this.playCardSelectionAnimation();
      },
      this
    );
  }
  // Set selection free spins value with response
  private setFreeSpinsValue(): void {
    const selectionFreeSpins: number[] = (ingenuity.parserModel as GameParserModel).getAllSelectionfreeSpins();
    selectionFreeSpins.forEach((freeSpin: number, index: number) => {
      const freeSpins: Label = this.view.getLabelById("freeSpin" + index) as Label;
      freeSpins.setText(String(freeSpin));
    }, this);
  }

  // Add to play selection screen box animation
  private playSelectionIntroSpine() {
    this.showBooksWithBoxSync();
    this.enableButton();
    this.selectionScreenContainer.visible = false;
    setTimeout(() => {
      this.selectionScreenContainer.alpha = 0;

      this.selectionScreenContainer.visible = true;

      const fadeInTween = ingenuity.currentGame.add.tween(this.selectionScreenContainer);
      fadeInTween.to({ alpha: 1 }, 1000, Linear.None, true, 0, 0, false);
      dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
      dispatcher.fireEvent(
        SlotEventConstantsBehavior.CHANGE_BACKGROUND,
        SlotConstantsBehavior.SELECTION_SCREEN_BG_SHOW
      );
      fadeInTween.onComplete.addOnce(() => {});
    }, 10);
  }

  /**
   * to show books with sync of suitcase animation
   */
  private showBooksWithBoxSync(): void {
    this.disableButton();
    this.playBannerAnimation(this.FIRST_CARD);
    this.playBannerGlowAnimation(this.FIRST_CARD);
    delayedCall(
      "showSelectedBook",
      700,
      () => {
        killDelayedCall("showSelectedBook");
        this.playSelectionScreenBgSound();
        !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_SELECTION_SCREEN);
      },
      this
    );
  }

  private playSelectionScreenBgSound(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      if (
        (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD)
      ) {
        (ingenuity.soundManager as any).stop(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.MINIGAME_MUSIC,
          1,
          true,
          gameConstants.SOUND_LIST_POSTLOAD
        );
        // (ingenuity.soundManager as any).playSound(SoundConstantGame.MINIGAME_POPUP_APPEAR, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
      }
      (ingenuity.soundManager as any).playSound(
        SoundConstantGame.MINIGAME_MUSIC,
        1,
        true,
        gameConstants.SOUND_LIST_POSTLOAD
      );
      // (ingenuity.soundManager as any).playSound(SoundConstantGame.MINIGAME_POPUP_APPEAR, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
    }
  }

  /**
   * to play banner animation on selection screen
   */
  private playBannerAnimation(index: number): void {
    const selectionScreenType: string = "copper";
    const cardNumbers: Container = this.view.getContainerByID(`${selectionScreenType}SelectionCardContainer_${index}`);
    cardNumbers.visible = true;
    const backGlowSpine: SpineBase = cardNumbers.children[0];
    const fireEffect: SpineBase = cardNumbers.children[3];
    backGlowSpine.playAnim("back_glow", true);
    fireEffect.playAnim("ball_fire_effect_in", false);
    fireEffect.onComplete.addOnce(() => {
      fireEffect.playAnim("ball_fire_effect_loop", true);
    }, this);

    if (this.selectedCardNum === undefined) {
      if (index < this.TOTAL_CARD) {
        this.playBannerAnimation(index + 1);
      } else {
        return;
      }
    }
  }

  //To play glow animations one after the other continously
  private playBannerGlowAnimation(index: number): void {
    const selectionScreenType: string = "copper";
    //play shine animation on cards one by one
    const cardNumbers: Container = this.view.getContainerByID(`${selectionScreenType}SelectionCardContainer_${index}`);
    cardNumbers.visible = true;
    cardNumbers.children[2].onComplete.dispose();
    cardNumbers.children[2].playAnim(`base_glow`, false);
    cardNumbers.children[2].onComplete.addOnce(() => {
      if (this.selectedCardNum === undefined) {
        const nextIndex = index === this.TOTAL_CARD ? this.FIRST_CARD : index + 1;
        this.playBannerGlowAnimation(nextIndex);
      }
    });
  }

  /**
   * Method to handle selection card
   */
  private handleCardClick(button: ButtonBase): void {
    const cardnumber: number = button.json.cardNumber;
    this.selectedCardNum = cardnumber;
    // this.hideBannerAnimation()
    this.disableButton();
    this.sendSelection();
    // this.disableCards();
    this.playCardSelectionAnimation();
  }

  // Add to play card selection animation
  private playCardSelectionAnimation(): void {
    const cardNumber: number = this.selectedCardNum + 1;
    const freeSpinType: string = "copper";
    const cardContainer: Container = this.view.getContainerByID(`${freeSpinType}SelectionCardContainer_${cardNumber}`);
    this.addSelectedContainerOnTop(cardContainer);
    cardContainer.children[0].onComplete.dispose();
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.MINIGAME_CHOOSE,
      1,
      false,
      gameConstants.SOUND_LIST_POSTLOAD
    );
    cardContainer.children[0].onComplete.addOnce(() => {
      this.afterCardSelectionAnimation(freeSpinType, cardContainer, cardNumber);
    }, this);
  }

  private addSelectedContainerOnTop(cardContainer: Container): void {
    const cardMainContainer: Container = this.view.getContainerByID(`selectionCardContainerCopper`);
    cardMainContainer.addChild(cardContainer);
  }

  private afterCardSelectionAnimation(fsType: string, cardContainer: Container, cardNumber: number): void {
    const horizontalCardPosition: number = 235;
    const moveDiagonal: ITween = ingenuity.currentGame.add
      .tween(cardContainer)
      .to({ x: horizontalCardPosition, y: -228 }, 300, Linear.None, true, 0, 0, false);
    this.fadeDiscardedContainers(fsType, cardNumber);
    this.addFadeOutTween(this.view.getContainerByID("selectionCardsStaticTextContainer"), 300);
    moveDiagonal.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(moveDiagonal);
      // dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW)
      this.fadeSelectedCardWithDelay(cardContainer);
    });
  }

  private fadeSelectedCardWithDelay(container: Container): void {
    delayedCall(
      "selectedCardDelay",
      1500,
      () => {
        killDelayedCall("selectedCardDelay");
        this.addFadeOutTween(container, 400, () => {});
        const blastSpine = this.view.getSpineById("backBlastEffect");
        blastSpine.playAnim("out_effect", false);
        dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BG, {
          name: SlotConstantsBehavior.SELECTION_SCREEN_BG_SHOW,
          duration: 100,
        });
        dispatcher.fireEvent(SlotEventConstants.SHOW_BASEGAME_VIEW);
        ingenuity.configData.selectionScreenShowing = false;

        this.fadeOutSelectionScreen();
      },
      this
    );
  }

  //fade out containers
  private addFadeOutTween(assetContainer: Container, time: number, callback?: Function): void {
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_SELECTION_SCREEN);
    const fadeAlpha1: ITween = ingenuity.currentGame.add
      .tween(assetContainer)
      .to({ alpha: 0 }, time, Linear.None, true, 0, 0, false);
    fadeAlpha1.onComplete.addOnce(() => {
      !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.SHOW_BASE_GAME_PORTRAIT_WIN_MTR);
      ingenuity.currentGame.tweens.remove(fadeAlpha1);
      callback && callback();
    });
  }

  // fade unselected fs containers
  private fadeDiscardedContainers(fsType: string, cardNumber: number): void {
    const containerIds = this.btnContainerIDs.filter((id) => id !== cardNumber);
    const containers = containerIds.map((id) => this.view.getContainerByID(`${fsType}SelectionCardContainer_${id}`));
    containers.forEach((container) => {
      this.addFadeOutTween(container, 300);
    });
  }
  // Fade out selection screen
  private fadeOutSelectionScreen(): void {
    const fadeOutTween: ITween = ingenuity.currentGame.add
      .tween(this.selectionScreenContainer)
      .to({ alpha: 0 }, 600, Linear.None, true, 0, 0, false);
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.MINIGAME_POPUP_DISAPPEAR,
      1,
      false,
      gameConstants.SOUND_LIST_POSTLOAD
    );

    fadeOutTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeOutTween);
      ingenuity.configData.selectionScreenResponse && dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      ingenuity.configData.isSelectionComplete = true;
      ingenuity.configData.selectionScreenResponse = false;
    }, this);
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.SHOW_BASE_GAME_PORTRAIT_WIN_MTR);
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_SELECTION_SCREEN);
  }

  // Add to show unselected disable cards
  private disableCards(): void {
    // const totalCards: number = 3;
    // for (let i = 0; i < totalCards; i++) {
    //   i !== this.selectedCardNum && (this.view.getContainerByID("selectionDisableCardContainer" + i).visible = true);
    // }
  }

  /**
   * Add to send free game selection request
   */
  private sendSelection(): void {
    dispatcher.fireEvent(eventDispatchers.SEND_FREE_GAME_SELECTION_REQUEST, this.selectedCardNum);
  }

  // Add to disable button click
  private disableButton(): void {
    this.greenSelectionCard.setIsInputEnabled(false);
    this.blueSelectionCard.setIsInputEnabled(false);
    this.pinkSelectionCard.setIsInputEnabled(false);
  }

  // Add to enable button click
  private enableButton(): void {
    this.greenSelectionCard.setIsInputEnabled(true);
    this.blueSelectionCard.setIsInputEnabled(true);
    this.pinkSelectionCard.setIsInputEnabled(true);
  }

  /**
   * Method is for reset the data.
   */
  public reset(): void {
    this.view.destroy();
    this.unSubscribeEvents();
    this.selectionScreenContainer.alpha = 1;
  }
}
